import loc from 'owa-localize';
import { calendarNotificationsBarAddGroupEvents } from 'owa-locstrings/lib/strings/calendarNotificationsBarAddGroupEvents.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { lazyShowCalendarNotification } from 'owa-calendar-notification-bar';

/**
 * Route handler for add group events deeplink
 */
export default function groupCalendarRouteHandler() {
    // The server would have already added the group events to the user's calendar, we just need to show a toast to the user
    // informing that the events are being copied to their calendar
    lazyShowCalendarNotification.import().then(showCalendarNotification => {
        showCalendarNotification(
            'addGroupEventsDeeplink',
            'Surface',
            loc(calendarNotificationsBarAddGroupEvents),
            { icon: ControlIcons.CheckMark }
        );
    });
}
